import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { tiposContenidoSelector } from '../../selectors/contenidoSelector'
import * as contenidoActions from '../../reducers/ContenidoReducer/actions'
import ContenidoNuevo from '../../components/Contenido/contenidoNuevo'
import * as Notification from '../../components/Common/notification'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import moment from 'moment'

class ContenidoNuevoContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            idTipoContenidoSelected: this.props.dataContenido.tiposContenido && this.props.dataContenido.tipoContenidoSelected ? this.props.dataContenido.tipoContenidoSelected : undefined,
            usuarioCargado: false,
            tiposContenidoCargados: this.props.dataContenido.tiposContenido ? true : false,
            nombre: undefined,
            tipoContenidoSelected: this.props.dataContenido.tiposContenido ? this.props.dataContenido.tiposContenido.find(x => x.idTipoContenido === this.props.dataContenido.tipoContenidoSelected) : undefined,
            error: {},
            textoLargo: undefined,

            pathImg: undefined,
            currentFile: undefined,
            fechaActivacion: undefined,
            fechaDesactivacion: undefined,
        }

        if (this.props.dataContenido.tiposContenido === undefined) {
            this.props.sagaGetTiposContenido()
        }
        localStorage.setItem('idTipoContenidoSelected', JSON.stringify({idTipoContenidoSelected:this.props.dataContenido.tipoContenidoSelected}));
    }

    componentDidUpdate = () => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){                    
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if (this.state.tiposContenidoCargados === false && this.props.dataContenido.tiposContenido !== undefined) {
            let idTipoContenidoSelected = this.props.dataContenido.tiposContenido[0].idTipoContenido
            this.setState({tiposContenidoCargados: true, idTipoContenidoSelected: idTipoContenidoSelected, tipoContenidoSelected:this.props.dataContenido.tiposContenido[0]}, () => {
                //buscar contenido
                //this.props.sagaGetContenido(tipoContenidoSelected)
            })
        }
    }

    handleOnClickDia = (fecha) => {
        this.setState(fecha)
    }

    handleOnChange = (e, ) => {
        let value = e.target.value
        let name = e.target.name
        
        let pathImg = this.state.pathImg
        let currentFile = this.state.currentFile

        if(name === "idTipoContenidoSelected"){
            pathImg = undefined
            currentFile = undefined

            let item = undefined
            if(this.props.dataContenido.tiposContenido){
                item = this.props.dataContenido.tiposContenido.find( x => x.idTipoContenido === value)
            }

            this.setState({
                [name]: value, 
                tipoContenidoSelected: item,
                pathImg: pathImg,
                currentFile: currentFile,
                textoLargo: undefined
            })

            return
        }
        
        this.setState({
            [name]: value
        })
    }

    handleOnSave = () => {
        
        let error = {}
        let flag = false

        if(this.state.idTipoContenidoSelected === undefined){
            error.tipoContenido = "Seleccione un tipo de contenido"
            flag = true
        }
        
        
        if(this.state.tipoContenidoSelected && this.state.tipoContenidoSelected.nombre !== "Preguntas frecuentes"){
            if(this.state.nombre === undefined || this.state.nombre === "" || this.state.nombre === null){
                error.nombre = "Ingrese un nombre para el contenido"
                flag = true
            }
            
            if(this.state.nombre !== undefined && this.state.nombre.length > 50){
                error.nombre = "Logitud máxima es de 50 caracteres"
                flag = true
            }

            if((this.state.idTipoContenidoSelected === 1 || this.state.idTipoContenidoSelected  === 2) && 
            (this.state.pathImg === undefined || this.state.currentFile  === undefined)){
                error.imagen = "Debe arrastrar o elegir una imagen"
                flag = true
            }

            if((this.state.fechaActivacion === null) || (this.state.fechaDesactivacion === null)) {
                error.fecha = "Debe ingresar una fecha"
                flag = true
            }

            if(moment(this.state.fechaDesactivacion).isSameOrBefore(this.state.fechaActivacion)) {
                    error.fecha = "Debe ser mayor o igual a la fecha de inicio."
                    flag = true
            }
        }
        else{
            if(this.state.nombre === undefined || this.state.nombre === "" || this.state.nombre === null){
                error.nombre = "Ingrese una pregunta para el contenido"
                flag = true
            }

            if(this.state.nombre !== undefined && this.state.nombre.length > 510){
                error.nombre = "Longitud máxima es de 510 caracteres"
                flag = true
            }

            if(this.state.textoLargo === undefined || this.state.textoLargo === "" || this.state.textoLargo === null){
                error.textoLargo = "Ingrese una respuesta para la pregunta"
                flag = true
            }
        }        

        //agregar validacion de archivo subido        
        this.setState({error: error}, () => {
            if (!flag) {
                let payload = {
                    idTipoContenido: this.state.idTipoContenidoSelected,
                    idUsuario: this.props.usuario ? this.props.usuario.id : undefined,
                    nombre: this.state.nombre,
                    file: this.state.currentFile,
                    textoLargo: this.state.textoLargo,
                    fechaActivacion: this.state.fechaActivacion,
                    fechaDesactivacion: this.state.fechaDesactivacion,
                }

                localStorage.setItem('idTipoContenidoSelected', JSON.stringify({idTipoContenidoSelected:this.state.idTipoContenidoSelected}));

                payload.callback = () => {
                    this.props.history.goBack();                    
                    //window.location.hash = '/Contenido'
                }

                this.props.sagaSabeContenido(payload)
            }
        })
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length !== 0){
            if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.")
            if (rejectedFiles.length > 1) Notification.showError("Se permite solo una imagen como portada de catálogo.")

        }
        else{
            if (acceptedFiles.length !== 0) {
                
                let currentFile = acceptedFiles[0]

                if (currentFile.type === 'image/gif') {
                    // Si es un GIF no lo comprimo ni redimensiono
                    let file = URL.createObjectURL(currentFile)
                    this.setState({
                        pathImg: file,
                        currentFile: currentFile,
                        error: { ...this.state.error, imagen: '' }
                    });
                } else {
                    let tipoContenidoSelected = this.state.tipoContenidoSelected
    
                    // genero una imagen para conocer sus dimesiones
                    let _self = this
                    let img = new Image()
                    img.onload = function () {
                        
                        let width = this.width
                        let height = this.height
    
                        if(tipoContenidoSelected && tipoContenidoSelected.idTipoContenido === 1){
                            width = 1417
                            height = 222
                        }
    
                        if(tipoContenidoSelected && tipoContenidoSelected.idTipoContenido === 2){
                            width = 481
                            height = 627
                        }
    
                        // comprimo la imagen
                        let newSize = calculateNewSize(width, height, width*2, height*2)
                        compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                    }
                    img.src = URL.createObjectURL(currentFile)
                }
            }
        }                
    }

    onImageCompressed = (currentFile) => {
        //guardo en el estado una copia, para usarla al momento de guardar los recortes
        let currentFileCopy = currentFile
        let file = URL.createObjectURL(currentFile)
        
        this.setState({
            pathImg: file,
            currentFile: currentFileCopy,
            error: {...this.state.error, imagen: ''} 
        })
    }

    render() {
        return (
            <ContenidoNuevo 
                tipoContenidoSelected={this.state.tipoContenidoSelected}
                idTipoContenidoSelected={this.state.idTipoContenidoSelected}
                tiposContenido={this.props.dataContenido.tiposContenido}
                nombre={this.state.nombre}
                textoLargo={this.state.textoLargo}
                fechaActivacion={this.state.fechaActivacion}
                fechaDesactivacion={this.state.fechaDesactivacion}
                error={this.state.error}
                pathImg={this.state.pathImg}
                handleOnChange={this.handleOnChange}
                handleOnSave={this.handleOnSave}
                handleOnDropFile={this.handleOnDropFile}
                handleOnClickDia={this.handleOnClickDia}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...contenidoActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        dataContenido: tiposContenidoSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContenidoNuevoContainer)